export interface RouteDetail {
  routeDetailName: string;
  isActive: boolean;
}

export const ROUTEDETAIL = 'ROUTEDETAIL';

export const RESET_RADAR_ROUTE_DETAIL = 'RESET_RADAR_ROUTE_DETAIL';

export const resetRadarRouteDetail = () => ({
  type: RESET_RADAR_ROUTE_DETAIL,
});

export const setRadarRouteDetail = (payload: RouteDetail) => ({
  type: ROUTEDETAIL,
  payload,
});
